import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

import { DatasetMetainfoService } from "./dataset-metainfo.service";
import { DatePipe } from "@angular/common";
import { DatasetMetainfo, ExternalReference } from "@models/mood/dataset-metainfo";
import { DatasetListingService } from "../dataset-listing.service";
import { Dataset } from "@models/mood/dataset";
import { FOURIER_EXPLANATION_TEXT, TIMESERIES_EXPLANATION_TEXT } from "src/app/constant";
import { COVARIATE_DATASET_TYPE_ENUM } from "@models/mood/covariates/dataset";
import { Provider } from "@models/mood/general/provider";

export interface DatasetMetainfoDialogData {
  dataset_id: string;
  dataset_name: string;
  metainfo_id?: string;
}

@Component({
  selector: 'mood-dataset-metainfo-dialog',
  templateUrl: 'dataset-metainfo-dialog.component.html',
  styleUrls: ['dataset-metainfo-dialog.component.scss'],
  providers: [DatePipe]
})
export class DatasetMetainfoDialogComponent implements OnInit {
  public metainfo?: DatasetMetainfo;
  public externalReferences?: ExternalReference[];

  public providers?: Provider[];
  public short_description?: string;
  public dataset_type_explanation?: string;

  public get dataLoaded() {
    return !!this.metainfo;
  }

  public get hasMetainfoSet() {
    return !!this._data.metainfo_id;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: DatasetMetainfoDialogData,
    private _datePipe: DatePipe,
    private _datasetMetainfoService: DatasetMetainfoService,
    private _dataListingServie: DatasetListingService
  ) { }

  ngOnInit(): void {
    this.initializeMetainfo();
  }

  public get metainfoTimestamps() {
    return `Initially added on ${this._datePipe.transform(this.metainfo!.first_retrieved)}, last checked on ${this._datePipe.transform(this.metainfo!.last_retrieved)}, last update on ${this._datePipe.transform(this.metainfo!.last_updated)}`;
  }

  public get metainfoTimespan() {
    return `${this._datePipe.transform(this.metainfo?.timespan?.start_date)} - ${this._datePipe.transform(this.metainfo?.timespan?.end_date)}`;
  }

  private async initializeMetainfo() {
    if (this._data.metainfo_id) {
      await this._loadMetainfo();
    }

    await this.loadDatasetInfo();
  }

  private async _loadMetainfo() {
    this.metainfo = await this._datasetMetainfoService.getExistingDatasetMetainfo(this._data.metainfo_id!);
  }

  private async loadDatasetInfo() {
    const dataset = await this._dataListingServie.findDatasetById(this._data.dataset_id);

    const providers = await this._dataListingServie.getProviders();

    this.externalReferences = dataset?.external_references;
    this.providers = dataset?.providers?.map(datasetProvider => providers.find(provider => provider.id === datasetProvider.provider_id)!);

    this.short_description = dataset?.description ?? "";

    if(dataset?.type === COVARIATE_DATASET_TYPE_ENUM.TIMESERIES) {
      this.dataset_type_explanation = TIMESERIES_EXPLANATION_TEXT;
    }
    if(dataset?.type === COVARIATE_DATASET_TYPE_ENUM.FOURIER) {
      this.dataset_type_explanation = FOURIER_EXPLANATION_TEXT;
    }
  }

  public get datasetName() {
    return this._data.dataset_name;
  }
}
